import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AsyncInternalNoticeListComponent, AsyncInternalNoticeDetailComponent, AsyncInternalNoticeCreateComponent, AsyncInternalNoticeModifyComponent } from 'Components/AsyncComponent/AsyncComponent';

const InternalNotice = () => {
  const location = useLocation();
  if (location.pathname === '/admin/internal-notice') {
    return <Navigate to="/admin/internal-notice/list" />;
  }

  return (
    <div className="content-wrapper">
      <Routes>
        <Route path="/list" element={<AsyncInternalNoticeListComponent />} />
        <Route path="/detail/:id" element={<AsyncInternalNoticeDetailComponent />} />
        <Route path="/create" element={<AsyncInternalNoticeCreateComponent />} />
        <Route path="/modify/:id" element={<AsyncInternalNoticeModifyComponent />} />
      </Routes>
    </div>
  );
};
export default InternalNotice;
